import { Drawer, Spin } from 'antd'
import React, { useState } from 'react'
import BaplieOrRestowHistory from './BaplieOrRestowHistory'
import MoreInfoModal from 'components/MoreInfoModal'
import PropTypes from 'prop-types'
import { QuestionCircleOutlined } from '@ant-design/icons'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

import './baplieOrRestowHistoryDrawer.less'

const BaplieOrRestowHistoryDrawer = ({
  baplieData,
  isDownloading,
  isOpen,
  onClose,
  onDownload,
}) => {
  const { t } = useTranslation()
  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false)

  const openMoreInfoModal = () => setShowMoreInfoModal(true)
  const closeMoreInfoModal = () => setShowMoreInfoModal(false)
  const isBusy = isDownloading

  return (
    <>
      <Drawer
        closable={!isBusy}
        maskClosable={!isBusy}
        onClose={isBusy ? undefined : onClose}
        open={isOpen}
        placement="right"
        size="large"
        title={
          <div className="baplie-or-restow-drawer__title">
            <Text className="baplie-or-restow-drawer__title-text">
              {t('portCall.shipOverview.baplieOrRestowHistory')}
            </Text>

            <QuestionCircleOutlined
              className="baplie-or-restow-drawer__help"
              onClick={openMoreInfoModal}
            />
          </div>
        }
      >
        <div className="baplie-or-restow-drawer__content">
          {isBusy && (
            <div className="baplie-or-restow-drawer__loading-overlay">
              <Spin size="large" />
            </div>
          )}

          <BaplieOrRestowHistory
            baplieData={baplieData}
            isDownloading={isDownloading}
            onDownload={onDownload}
          />
        </div>
      </Drawer>

      {/* More Info Modal */}
      {showMoreInfoModal && (
        <MoreInfoModal
          isVisible={showMoreInfoModal}
          onClose={closeMoreInfoModal}
          title={t('portCall.shipOverview.baplieOrRestowHistory')}
        >
          <div>
            <Text>
              {t('portCall.shipOverview.baplieOrRestowInfo.historyDescription')}
            </Text>
          </div>
        </MoreInfoModal>
      )}
    </>
  )
}

BaplieOrRestowHistoryDrawer.propTypes = {
  baplieData: PropTypes.arrayOf(
    PropTypes.shape({
      devices: PropTypes.arrayOf(
        PropTypes.shape({
          deviceName: PropTypes.string.isRequired,
          deviceid: PropTypes.string.isRequired,
          syncAt: PropTypes.string,
          syncStatus: PropTypes.number.isRequired,
        })
      ).isRequired,
      filename: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      source: PropTypes.string,
      type: PropTypes.string.isRequired,
      uploadedTime: PropTypes.string.isRequired,
    })
  ),
  isDownloading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
}

export default BaplieOrRestowHistoryDrawer
